import { cancelWarnWhenLeaving } from '../../components/prevent_unsaved_changes';
const toggleEditView = function (element) {
    const form = element.querySelector('.js-comments_form_edit');
    const body = element.querySelector('.js-comment_body');
    const actions = element.querySelector('.js-comment_actions');
    form && form.classList.toggle('hide');
    body && body.classList.toggle('hide');
    actions && actions.classList.toggle('hide');
};
window.up.compiler('.js-comments_form', function (form) {
    const textarea = form.querySelector('textarea');
    const btnSubmit = form.querySelector('button[type=submit]');
    const btnCancel = form.querySelector('button[type=button]');
    if (textarea) {
        const initialTextareaValue = textarea.value.trim();
        window.up.on(textarea, 'input', undefined, function (_ev, el) {
            const inputValue = el instanceof HTMLTextAreaElement && el.value.trim();
            if (btnSubmit) {
                if (inputValue && inputValue !== initialTextareaValue) {
                    btnSubmit.disabled = false;
                }
                else {
                    btnSubmit.disabled = true;
                }
            }
        });
        if (btnCancel) {
            window.up.on(btnCancel, 'click', undefined, function () {
                textarea.value = initialTextareaValue;
                // Need to trigger an input event here so the textarea autogrows (see textarea_autogrow.js)
                textarea.dispatchEvent(new Event('input'));
                form.parentElement && toggleEditView(form.parentElement);
                cancelWarnWhenLeaving(form);
            });
        }
    }
});
window.up.compiler('.js-comment_editable', function (element) {
    const btnEdit = element.querySelector('.js-comment_btn_edit');
    if (btnEdit && element instanceof HTMLElement) {
        window.up.on(btnEdit, 'click', undefined, function () {
            toggleEditView(element);
        });
    }
});
window.up.compiler('.js-toggle_comment_replies', function (element) {
    window.up.on(element, 'click', undefined, function () {
        const repliesWrapper = document.querySelector('#' + element.getAttribute('aria-controls'));
        const replies = repliesWrapper === null || repliesWrapper === void 0 ? void 0 : repliesWrapper.querySelector('*[data-allow-toggle]');
        if (repliesWrapper) {
            if ((replies === null || replies === void 0 ? void 0 : replies.dataset.allowToggle) === 'true' && repliesWrapper.style.display === 'block') {
                repliesWrapper.style.display = 'none';
                element.setAttribute('aria-expanded', 'false');
            }
            else {
                repliesWrapper.style.display = 'block';
                element.setAttribute('aria-expanded', 'true');
            }
        }
    });
});
